import { render } from "./DomainShopList.vue?vue&type=template&id=3f98d0ba&scoped=true"
import script from "./DomainShopList.vue?vue&type=script&lang=js"
export * from "./DomainShopList.vue?vue&type=script&lang=js"

import "./DomainShopList.vue?vue&type=style&index=0&id=3f98d0ba&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f98d0ba"]])

export default __exports__